import React from "react";
import {Link} from 'react-router-dom';
import VisaType from "../component/VisaType";
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const Visa = () => {
    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Visa</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/visa`}/>
            </Helmet>
            <main className="main">
                <BreadCumb image="visa_services.webp" />
                <VisaType />
            </main>
        </>

    );
}

export default Visa;